var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"filled":"","dense":"","label":"Search","clearable":""},on:{"input":_vm.doSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }